import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { AppRoutes } from '../../enums/Approutes';

const BillingFailed: React.FC = () => {
    const navigate = useNavigate();

    const handleBackToBilling = () => {
        if (window.opener && !window.opener.closed) {
            window.close();
        } else {
            navigate(AppRoutes.BILLING);
            window.close();
        }
    };

    return (
        <div className='max-h-screen w-full px-4 py-8 md:px-[23%] md:py-14'>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    textAlign: 'center'
                }}
            >
                <ErrorIcon
                    sx={{
                        fontSize: 80,
                        color: '#f44336',
                        mb: 3
                    }}
                />
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
                    Pagamento Fallito
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, color: '#666' }}>
                    Ops, sembra che il pagamento non sia andato a buon fine. Puoi riprovare.
                </Typography>
                <Button
                    variant="contained"
                    onClick={handleBackToBilling}
                    sx={{
                        backgroundColor: '#E9495A',
                        '&:hover': { backgroundColor: '#E6263B' },
                        px: 4,
                        py: 1.5
                    }}
                >
                    Torna Indietro e Riprova
                </Button>
            </Box>
        </div>
    );
};

export default BillingFailed;